<template>
  <div>
    <div
      style="position: fixed; top: 0; left: 0; right: 0; z-index: 999"
      class="payment"
    >
      <van-nav-bar title="合同详情" @click-left="goBack" left-arrow>
      </van-nav-bar>
    </div>

    <div style="padding-top: 46px">
      <div class="info-title">基本信息（只读）</div>

      <div
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
      >
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">内部合同号</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.bill_no }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">内部状态</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.status_txt }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">合同号</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.contract_numbe }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">合同状态</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.contract_state_txt }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">业务员</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">
              {{ info.staff ? info.staff.name : "" }}
            </div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">创建时间</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.created_at }}</div>
          </div>
        </div>
      </div>

      <div class="info-title">产品信息和费用</div>

      <div
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
      >
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">模板类型</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <select
              v-model="contract_type"
              style="padding: 0"
              class="line-select"
              disabled
              onfocus="this.blur()"
            >
              <option value="A00001">境内游</option>
              <option value="C00001">出境游</option>
              <option value="F00001">赴台游</option>
              <option value="E00001">代订代办</option>
            </select>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">线路名称</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="必填"
              v-model="contract_name"
            />
          </div>
        </div>

        <div v-if="contract_type == 'A00001' || contract_type == 'C00001'">
          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">出发日期</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.begin_time_select ? $refs.begin_time_select.dateStr : ''
                "
                @click="$refs.begin_time_select.doSelect()"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">结束日期</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.end_time_select ? $refs.end_time_select.dateStr : ''
                "
                @click="$refs.end_time_select.doSelect()"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">共</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                style=""
                placeholder="必填"
                v-model="contract_days"
                type="number"
              />
              <div class="suffix-wrapper">日</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">饭店住宿</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                style=""
                placeholder="必填"
                v-model="contract_nights"
                type="number"
              />
              <div class="suffix-wrapper">夜</div>
            </div>
          </div>
         
          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4"><span class="input-tag">成人</span></div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_adult_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">儿童(不满14)</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_child_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">导游服务费</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_service_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">单房差</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_single_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

        </div>


<div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">成人人数</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_adult_count"
                type="number"
              />

              <div class="suffix-wrapper">人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">儿童人数</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_child_count"
                type="number"
              />

              <div class="suffix-wrapper">人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">旅游费用合计</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_price"
                type="number"
              />

              <div class="suffix-wrapper">元</div>
            </div>
          </div>

        </div>


<div v-if="contract_type == 'A00001' || contract_type == 'C00001'">

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">支付方式</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <!-- <input
              class="line-input"
              placeholder="非必填"
              v-model="bank_account"
            /> -->
              <select
                v-model="contract_payway"
                style="padding: 0"
                class="line-select"
              >
                <!-- <option value="1">现金</option> -->
                <option value="2">对公转账</option>
                <option value="3">线上支付</option>
              </select>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">支付时间</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <!-- <input
              class="line-input"
              placeholder="非必填"
              v-model="bank_account"
            /> -->
              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.pay_time_select ? $refs.pay_time_select.dateStr : ''
                "
                @click="$refs.pay_time_select.doSelect()"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">其他约定事项</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_pay_remark"
              />
            </div>
          </div>
          <div style="font-size: 12px; line-height: 18px; opacity: 0.6">
            注：未尽事宜，旅游者和旅行社双方协商一致，可列入补充条款。（如合同空间不够，可另附纸张上传附件）
          </div>
        </div>
      </div>

      <div class="info-title">游客代表和游客信息</div>

      <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
        <div
          v-for="(item, index) in course_data"
          :key="index"
          style="padding-bottom: 24px"
          @click="editPerson(item, index)"
        >
          <div style="position: relative">
            <div style="font-size: 14px; font-weight: bold">
              {{ item.name ? item.name : "??" }}
              <span
                v-if="item.isSigner == '1'"
                style="display: inline-block; margin-left: 6px; padding: 0 6px; line-height: 18px; height: 18px; font-size: 12px; color: #fff; background: #ff5722; border-radius: 9px; vertical-align: middle;"
              >签约人</span>
            </div>
            <div style="font-size: 12px; margin-top: 6px">
              {{ cardtypeTxt(item.cardtype) }}：{{ item.idcard }}
            </div>

            <div
              style="
                position: absolute;
                right: 0;
                font-size: 22px !important;
                top: 50%;
                transform: translateY(-50%);
                color: #1889f9 !important;
              "
            >
              <van-icon
                name="edit"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  font-size: 22px !important;
                  color: #1889f9 !important;
                "
              />
            </div>
          </div>
        </div>

        <a
          style="
            display: inline-block;
            width: 100%;
            border-radius: 0.125rem;
            line-height: 0.7rem;
            font-family: PingFangSC-Regular;
            font-size: 0.3rem;
            color: #1889f9;
            border: 1px solid #9f9f9f;
            text-align: center;
          "
          href="javascript:void(0);"
          v-on:click="addCourse"
          v-bind:class="{ inEdit: !nextStepValid }"
        >
          <van-icon
            name="add-o"
            style="
              display: inline-block;
              margin-right: 6px;
              vertical-align: middle;
            "
          />
          <span style="display: inline-block; vertical-align: middle"
            >添加游客</span
          >
        </a>
      </div>

      <div class="info-title">自愿购物及增加景点活动</div>

      <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
        <div
          v-for="(item, index) in shoppings"
          :key="index"
          style="padding-bottom: 24px"
          @click="editShopping(item, index)"
        >
          <div style="position: relative">
            <div style="font-size: 14px; font-weight: bold">
              {{ item.date || '未设置日期' }} · {{ item.shoppingPlace || '未设置购物地点' }}
            </div>
            <div style="font-size: 12px; margin-top: 6px">
              地点：{{ item.place || '-' }} / 商品：{{ item.goods || '-' }} / 停留：{{ item.stayDuration || '-' }} 分钟
            </div>

            <div
              style="position: absolute; right: 0; font-size: 22px !important; top: 50%; transform: translateY(-50%); color: #1889f9 !important;"
            >
              <van-icon name="edit" style="display: inline-block; vertical-align: middle; font-size: 22px !important; color: #1889f9 !important;" />
            </div>
          </div>
        </div>

        <a
          style="display: inline-block; width: 100%; border-radius: 0.125rem; line-height: 0.7rem; font-family: PingFangSC-Regular; font-size: 0.3rem; color: #1889f9; border: 1px solid #9f9f9f; text-align: center;"
          href="javascript:void(0);"
          v-on:click="addShopping"
          v-bind:class="{ inEdit: !nextStepValid }"
        >
          <van-icon name="add-o" style="display: inline-block; margin-right: 6px; vertical-align: middle;" />
          <span style="display: inline-block; vertical-align: middle">添加购物</span>
        </a>
      </div>

      <div v-if="contract_type == 'E00001'">
        <!-- <div class="info-title">机票预定</div>

        <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
          <div
            v-for="(item, index) in course_data"
            :key="index"
            style="padding-bottom: 24px"
            @click="editPerson(item, index)"
          >
            <div style="position: relative">
              <div style="font-size: 14px; font-weight: bold">
                {{ item.name ? item.name : "??" }}
              </div>
              <div style="font-size: 12px; margin-top: 6px">
                {{ cardtypeTxt(item.cardtype) }}：{{ item.idcard }}
              </div>

              <div
                style="
                  position: absolute;
                  right: 0;
                  font-size: 22px !important;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #1889f9 !important;
                "
              >
                <van-icon
                  name="edit"
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 22px !important;
                    color: #1889f9 !important;
                  "
                />
              </div>
            </div>
          </div>

          <a
            style="
              display: inline-block;
              width: 100%;
              border-radius: 0.125rem;
              line-height: 0.7rem;
              font-family: PingFangSC-Regular;
              font-size: 0.3rem;
              color: #1889f9;
              border: 1px solid #9f9f9f;
              text-align: center;
            "
            href="javascript:void(0);"
            v-on:click="addCourse"
            v-bind:class="{ inEdit: !nextStepValid }"
          >
            <van-icon
              name="add-o"
              style="
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
              "
            />
            <span style="display: inline-block; vertical-align: middle"
              >添加游客</span
            >
          </a>
        </div> -->

        <serviceitem ref="plane" title="机票预定" type="1"> </serviceitem>

        <serviceitem ref="hotel" title="酒店预定" type="2"> </serviceitem>

        <serviceitem ref="car" title="用车服务" type="3"> </serviceitem>

        <serviceitem ref="dao" title="导游服务" type="4"> </serviceitem>

        <serviceitem ref="visa" title="签证服务" type="5"> </serviceitem>

        <serviceitem ref="other" title="其他" type="6"> </serviceitem>


        <serviceitem ref="rule" title="通用条款" type="7"> </serviceitem>


        <!-- <serviceitem ref="other"  title="">

        </serviceitem> -->
      </div>

      <div v-if="contract_type == 'A00001' || contract_type == 'C00001'">
        <div class="info-title">其它约定信息</div>

        <div
          class="form-info-panel"
          style="padding-left: 0.4rem; text-align: left"
        >
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">意外伤害保险</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_insurance_method"
                style="padding: 0"
                class="line-select"
                placeholder="必选"
              >
                <!-- <option disabled value="">请选择</option> -->
                <option value="1">委托购买</option>
                <option value="2">自行购买</option>
              </select>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">保险产品名称</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_insurance_productname"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">最低成团人数</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_group_min_count"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">不成团约定</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_group_way"
                style="padding: 0"
                class="line-select"
                placeholder="必选"
              >
                <!-- <option disabled value="">请选择</option> -->
                <option value="1">委托其它旅行社</option>
                <option value="2">延期出团</option>
                <option value="3">改签其他线路出团</option>
                <option value="4">解除合同</option>
              </select>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">委托社名称</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_group_othername"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">拼团约定</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_group_agree"
                style="padding: 0"
                class="line-select"
                placeholder="必填"
              >
                <option value="1">同意</option>
                <option value="2">不同意</option>
              </select>
            </div>
          </div>

          <!-- <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">争议解决方式</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_dispute_way"
                style="padding: 0"
                class="line-select"
                placeholder="必选"
              >
              
                <option value="1">仲裁</option>
                <option value="2">依法向人民法院起诉</option>
              </select>
            </div>
          </div> -->

          <!-- <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">仲裁庭名称</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_dispute_tribunalname"
              />
            </div>
          </div> -->
        </div>
      </div>

      <div v-if="contract_type == 'A00001' || contract_type == 'C00001'">
        <div class="info-title">行程及附件上传</div>

        <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
          <div v-for="(item, index) in fileList" :key="item" style="padding-bottom: 24px">
            <div style="position: relative">
              <div style="font-size: 14px; font-weight: bold">
                {{ getFileNameFromUrl(item) }}
              </div>
              <div style="font-size: 12px; margin-top: 6px">
                上传类型：{{ isPdfUrl(item) ? "pdf" : "docx" }}
              </div>
              <div style="font-size: 12px; margin-top: 6px">
                <FileSizeCheck :url="item" :limit="8" />
              </div>

              <div
                style="
                  position: absolute;
                  right: 0;
                  font-size: 22px !important;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #1889f9 !important;
                "
                @click.stop="deleteFile(item, index)"
              >
                <van-icon
                  name="delete"
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 22px !important;
                    color: #1889f9 !important;
                  "
                />
              </div>
            </div>
          </div>

          <a
            style="
              display: inline-block;
              width: 100%;
              border-radius: 0.125rem;
              line-height: 0.7rem;
              font-family: PingFangSC-Regular;
              font-size: 0.3rem;
              color: #1889f9;
              border: 1px solid #9f9f9f;
              text-align: center;
              position: relative;
            "
            href="javascript:void(0);"
            v-bind:class="{ inEdit: !nextStepValid }"
          >
            <van-icon
              name="add-o"
              style="
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
              "
            />
            <span style="display: inline-block; vertical-align: middle"
              >添加文件</span
            >

            <input
              type="file"
              style="
                position: absolute;
                z-index: 999;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                opacity: 0;
              "
              accept="application/pdf,.docx"
              @change="getFile"
              ref="upload"
            />
          </a>
        </div>

        <div
          class="ps-text"
          style="padding: 0.2rem; text-align: left; opacity: 0.7"
        >
          注：只支持.pdf,.docx格式的文件。
        </div>
      </div>


      <!-- <div
        class="in-bl-line"
        style="padding: 0 0.5rem; margin-top: 0.5rem;"
        v-if="info.status == 1"
      >
        <a
          class="bt"
          href="javascript:void(0);"
          v-on:click="previewContract"
          style="background-color: #ff5722"
          v-bind:class="{ inEdit: !nextStepValid }"
          >生成预览</a
        >
        <div style="height: 1rem"></div>
      </div> -->



      <div
        class="in-bl-line"
        style="padding: 0 0.5rem; margin-top: 0.5rem;"
        v-if="info.status == 1"
      >
        <a
          class="bt"
          href="javascript:void(0);"
          v-on:click="saveContract"
          v-bind:class="{ inEdit: !nextStepValid }"
          >提交合同</a
        >
      </div>


      <div
        class="in-bl-line"
        style="padding: 0 0.5rem; margin-top: 0.5rem; margin-bottom: 2rem"
        v-if="info.status == 1"
      >
        <a
          class="bt"
          href="javascript:void(0);"
          v-on:click="doPreview"
          v-bind:class="{ inEdit: !nextStepValid }"
          style="background-color: #ffffff; color: #1889f9; border: 1px solid #1889f9;"
          >预览合同</a
        >
       
      </div>




      

      <div style="height: 200px;">

      </div>

    </div>

    <!-- <form style="display: none" id="data-form">
      <input
        id="fileTarget"
        ref="filElem"
        type="file"
        name="file"
        style="display: none"
        accept="image/gif,image/jpeg,image/png"
        @change="getFile"
      />
    </form> -->

    <CusDatePicker
      ref="begin_time_select"
      v-model="contract_begin_day"
    ></CusDatePicker>
    <CusDatePicker
      ref="end_time_select"
      v-model="contract_end_day"
    ></CusDatePicker>
    <CusDatePicker
      ref="pay_time_select"
      v-model="contract_pay_day"
    ></CusDatePicker>

    <!-- 购物日期选择器 -->
    <CusDatePicker
      ref="shopping_date_select"
      v-model="current_shopping.date"
    ></CusDatePicker>

    <van-image-preview v-model="show" :images="images" @change="onChange">
    </van-image-preview>

    <div style="position: fixed; bottom: 128px; right: 24px" @click="saveDraft">
      <div
        style="
          background-color: rgb(239, 239, 239);
          width: 40px;
          height: 40px;
          border-radius: 100%;
          position: relative;
        "
      >
        <img
          src="~@/assets/images/save_draft.png"
          class="ab-t-t-x-y"
          style="width: 20px; height: 20px"
        />
      </div>
    </div>

    <div style="position: fixed; bottom: 78px; right: 24px" @click="showMore">
      <div
        style="
          background-color: rgb(239, 239, 239);
          width: 40px;
          height: 40px;
          border-radius: 100%;
          position: relative;
        "
      >
        <img
          src="~@/assets/images/more.png"
          class="ab-t-t-x-y"
          style="width: 20px; height: 20px"
        />
      </div>
    </div>

    <!-- start of 游客编辑 -->
    <van-popup
      v-model="person_show"
      position="right"
      style="width: 82%; height: 100%; background: #f5f5f5; z-index: 99999"
    >
      <!--字符、注册年限、组合类型、注册类型、年限进行筛选-->

      <div
        style="
          box-shadow: 0px 2px 5px #eeeeee;
          background: #ffffff;
          margin-top: 2px;
        "
      >
        <van-cell title="" is-link value="关闭" @click="person_show = false" />
      </div>

      <!--用tab操作-->
      <div style="overflow-y: scroll; height: calc(100% - 90px)">
        <div style="padding: 12px">
          <van-form>
            <van-field
              name="checkboxGroup"
              label="姓名"
              v-model="current_person.name"
            >
            </van-field>
            <!-- 
            <van-field name="radio" label="证件类型">
                
            </van-field> -->

            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>证件类型</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <!-- <input type="text" name="radio" class="van-field__control" /> -->
                  <select
                    v-model="current_person.cardtype"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value="1">身份证</option>
                    <option value="4">护照</option>
                    <option value="6">回乡证</option>
                    <option value="8">其他</option>
                  </select>
                </div>
              </div>
            </div>

            <van-field
              name="checkboxGroup"
              label="证件号"
              v-model="current_person.idcard"
            >
            </van-field>

            <!-- 性别（非必填，男/女） -->
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>性别</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <select
                    v-model="current_person.gender"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value=""></option>
                    <option value="男">男</option>
                    <option value="女">女</option>
                  </select>
                </div>
              </div>
            </div>

            <van-field
              name="checkboxGroup"
              label="手机号码"
              v-model="current_person.phone"
            >
            </van-field>

            <!-- <van-field name="checkboxGroup" label="是否儿童"> </van-field> -->
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>是否儿童</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <!-- <input type="text" name="radio" class="van-field__control" /> -->
                  <select
                    v-model="current_person.is_child"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value="1">是</option>
                    <option value="2">否</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- 是否签约人 -->
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>是否签约人</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <select
                    v-model="current_person.isSigner"
                    style="padding: 0"
                    class="line-select"
                    :disabled="person_index === 0"
                  >
                    <option value="1">是</option>
                    <option value="0">否</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- <van-field
              name="checkboxGroup"
              label="地址"
              v-model="current_person.address"
              type="textarea"
              rows="2"
            >
            </van-field> -->
          </van-form>

          <div style="font-size: 12px;text-align: left;margin-top: 24px;">提示：①如团队签约，名单只需填写一个签约代表，剩余名单以表格形式上传至附件。②第一个用户必须是签约人。</div>
        </div>
      </div>

      <div style="position: absolute; left: 0; right: 0; bottom: 0">
        <div class="cus-row">
          <div class="cus-row-col-6">
            <van-button
              type="danger"
              block
              style="background: #ffffff; color: #000000; border: none"
              @click="deletePerson"
              >删除</van-button
            >
          </div>
          <div class="cus-row-col-6">
            <van-button type="danger" block @click="choseTemplate"
              >继续
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 自愿购物编辑 -->
    <van-popup
      v-model="shopping_show"
      position="right"
      style="width: 82%; height: 100%; background: #f5f5f5; z-index: 99999"
    >
      <div style="box-shadow: 0px 2px 5px #eeeeee; background: #ffffff; margin-top: 2px;">
        <van-cell title="" is-link value="关闭" @click="shopping_show = false" />
      </div>
      <div style="overflow-y: scroll; height: calc(100% - 90px)">
        <div style="padding: 12px">
          <van-form>
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>日期</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <input
                    class="van-field__control"
                    type="text"
                    readonly
                    :value="$refs.shopping_date_select ? $refs.shopping_date_select.dateStr : (current_shopping.date || '')"
                    @click="$refs.shopping_date_select.doSelect()"
                    placeholder="YYYY-MM-DD"
                  />
                </div>
              </div>
            </div>
            <van-field label="城市/地区" v-model="current_shopping.place" />
            <van-field label="购物场所" v-model="current_shopping.shoppingPlace" />
            <van-field label="主要商品" v-model="current_shopping.goods" />
            <van-field label="停留时长(分钟)" v-model="current_shopping.stayDuration" type="number" />
            <van-field label="备注" v-model="current_shopping.memo" type="textarea" rows="2" />
          </van-form>
        </div>
      </div>
      <div style="position: absolute; left: 0; right: 0; bottom: 0">
        <div class="cus-row">
          <div class="cus-row-col-6">
            <van-button type="danger" block style="background: #ffffff; color: #000000; border: none" @click="deleteShopping">删除</van-button>
          </div>
          <div class="cus-row-col-6">
            <van-button type="danger" block @click="shopping_show = false">完成</van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- end of 游客编辑 -->

    <!--分享弹出层-->
    <van-popup
      v-model="more_show"
      round="true"
      position="bottom"
      :style="{ 'min-height': '10%' }"
    >
      <div>
        <div class="van-share-sheet__options">
          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="goView"
            v-if="info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="newspaper-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">查看合同</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="refreshStatus"
            v-if="info.contract_state != 3 && info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="replay" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">更新状态</span>
          </div>

          <!-- <div role="button" tabindex="0" class="van-share-sheet__option" @click="goSms">
                        <img src="https://img01.yzcdn.cn/vant/share-sheet-link.png" class="van-share-sheet__icon" /><span class="van-share-sheet__name">签署链接</span>
                    </div> -->

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="resend"
            v-if="[1, 2].indexOf(info.contract_state) != -1 && info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="comment-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">签署短信</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="doCopy"
            v-if="[1, 2].indexOf(info.contract_state) != -1 && info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="brush-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">复制链接</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="deleteJobDraft"
            v-if="info.status == 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="delete" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">删除草稿</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="deleteContract"
            v-if="
              info.status != 1 && [1, 2, 3].indexOf(info.contract_state) != -1
            "
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="delete" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">作废合同</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="invalidateResend"
            v-if="info.status != 1 && [4].indexOf(info.contract_state) != -1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="comment-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">作废短信</span>
          </div>
        </div>

        <button
          type="button"
          class="van-share-sheet__cancel"
          @click="doShareShowCancel"
        >
          取消
        </button>
      </div>
    </van-popup>
  </div>
</template>


<script>
import common from "../assets/js/common";
import CusDatePicker from "../modules/cus_date_picker";
import { Dialog } from "vant";
import _ from "underscore";
import axios from "axios";
import { Toast } from "vant";
import serviceitem from "../components/serviceitem";
import FileSizeCheck from "../components/FileSizeCheck.vue";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  components: {
    CusDatePicker,
    serviceitem,
    FileSizeCheck,
  },
  data: function () {
    return {
      template_type: "",
      begin_time: "",
      price: "",
      pay_username: "",
      collection_username: "",
      pay_date: "",
      faceImg: "",
      tabIndex: 1,
      list: [],
      list_combine: [],
      more_show: false,
      taxlist: [],
      currentId: "",
      invoFlag: false,
      taxpayer_number: "",
      title: "",
      email: "",
      invoiceType: -1,
      chosenFlag: false,
      fillFlag: false,
      page_list: true,
      checked: false,
      detailFlag: false,
      detailItem: {},
      taxpayer_phone: "",
      taxpayer_bank: "",
      bank_account: "",
      showPicSrc: "",
      shouquanshu: "",
      taxpayer_address: "",
      contract_no: "",
      bank_name: "",
      remark: "",
      nextLock: "",
      show: false,
      person_show: false,

      id: this.$route.query.id,
      info: {},

      contract_type: "",
      contract_begin_day: "",
      contract_end_day: "",
      contract_pay_day: "",
      contract_name: "",

      contract_adult_price: "",
      contract_child_price: "",
      contract_adult_count: "",
      contract_child_count: "",
      contract_price: "",
      contract_pay_remark: "",
      contract_payway: "",

      contract_insurance_method: "",
      contract_insurance_productname: "",
      contract_group_min_count: "",
      contract_group_way: "",
      contract_group_othername: "",
      contract_group_agree: "",
      contract_dispute_tribunalname: "",
      contract_dispute_way: "",

      contract_days: "",
      contract_nights: "",

      course_data: [],
      person_index: -1,
      current_person: {},
      fileList: [],
      isTestMode: common.isTestMode(),
      shoppings: [],
      shopping_show: false,
      shopping_index: -1,
      current_shopping: {},
    };
  },
  methods: {
    deleteContract() {
      Dialog.confirm({
        title: "操作提醒",
        message: "确认要作废当前合同吗?",
      }).then(() => {
        // this.person_show = false;
        // _.remove(this.course_data,);
        // this.fileList.splice(index, 1);
        // this.person_index = -1;
        // common.mAlert(this, "重发短信成功");

        common
          .cusHttp(
            this,
            "/admin_user.php?action=cancel_contract",
            { id: this.id },
            "get"
          )
          .then((res) => {
            console.log("作废成功");
            common.mAlert(this, "作废成功");
            // this.goBack()
            this.initPage();
          });
      });
    },

    deleteJobDraft() {
      Dialog.confirm({
        title: "操作提醒",
        message: "确认要删除当前草稿吗?",
      }).then(() => {
        // this.person_show = false;
        // _.remove(this.course_data,);
        // this.fileList.splice(index, 1);
        // this.person_index = -1;
        // common.mAlert(this, "重发短信成功");

        common
          .cusHttp(
            this,
            "/admin_user.php?action=deleted_job",
            { id: this.id },
            "get"
          )
          .then((res) => {
            console.log("删除成功");
            common.mAlert(this, "删除成功");
            this.goBack();
          });
      });
    },

    goBack() {
      this.$router.push({ path: "/" });
    },
    invalidateResend() {
      console.log("重发短信");
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要重发签署短信，点击确认将自动发送？",
      }).then(() => {
        // this.person_show = false;
        // _.remove(this.course_data,);
        // this.fileList.splice(index, 1);
        // this.person_index = -1;
        common.mAlert(this, "重发短信成功");

        common.cusHttp(
          this,
          "/admin_user.php?action=contract_invalid_resend",
          { id: this.id },
          "get"
        );
      });
    },
    resend() {
      // contractResend({id: record.id}).then((res)=>{
      //   this.$message.success('重发短信成功')
      // })
      console.log("重发短信");
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要重发签署短信？",
      }).then(() => {
        // this.person_show = false;
        // _.remove(this.course_data,);
        // this.fileList.splice(index, 1);
        // this.person_index = -1;
        common.mAlert(this, "重发短信成功");

        common.cusHttp(
          this,
          "/admin_user.php?action=contract_resend",
          { id: this.id },
          "get"
        );
      });
    },

    refreshStatus() {
      // console.log("刷新状态", record)
      // syncContractStatus({id: record.id}).then((res)=>{
      //   this.$message.success('状态更新成功')
      //   this.$refs.table.refresh()
      // })

      Dialog.confirm({
        title: "操作提醒",
        message: "是否要手动更新状态？",
      }).then(() => {
        // common.mAlert(this, "重发短信成功");
        common
          .cusHttp(
            this,
            "/admin_user.php?action=sync_contract_status",
            { id: this.id },
            "get"
          )
          .then((res) => {
            common.mAlert(this, "更新状态成功");
            this.initPage();
          });
      });
    },

    doCopy() {
      common.mAlert(this, "复制成功");
      common.copy(this.info.contract_sign_url);
    },

    goView() {
      console.log("查看合同内容");
      window.open(this.info.contract_file_url, "_target");
    },

    showMore() {
      this.more_show = true;
    },
    doShareShowCancel() {
      this.more_show = false;
    },
    deleteFile(item, index) {
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要删除当前文件？",
      }).then(() => {
        // this.person_show = false;
        // _.remove(this.course_data,);
        this.fileList.splice(index, 1);
        // this.person_index = -1;
      });
    },
    isPdfUrl(url) {
      // 使用正则表达式判断地址是否以.pdf结尾
      const pdfPattern = /\.pdf$/i;
      return pdfPattern.test(url);
    },
    getFileNameFromUrl(url) {
      // 使用 URL 构造函数解析给定的 URL
      const parsedUrl = new URL(url);

      // 从路径中获取最后的部分，即文件名
      const pathname = parsedUrl.pathname;
      const fileName = pathname.substring(pathname.lastIndexOf("/") + 1);

      return fileName;
    },
    getFile() {
      const inputFile = this.$refs.upload.files[0];
      if (inputFile) {
        if (
          inputFile.type !==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
          inputFile.type !== "application/pdf"
        ) {
          alert("不是有效的docx,pdf文件！");
          return;
        }

        // var formElement = document.querySelector("#data-form");
        var formData = new FormData();
        formData.append("file", inputFile);

        axios
          .post(common.dynamicHost() + "/upload.php", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.$refs.upload.value = "";
            console.log("正常上传");
            console.log(res);
            res = res.data;
            if (res.errcode == 0) {
              this.fileList.push(common.dynamicHost() + res.path);
              return;
            }
            alert("异常上传");
          })
          .catch((err) => {
            this.$refs.upload.value = "";
            console.log("异常上传");
            alert("异常上传");
          });

        // uploadCertificate(formData).then((res) => {
        //   this.$refs.filElem.value = "";
        //   if (res.status === 1) {
        //     this.logo_path = res.img;
        //   } else {
        //     this.$notification["error"]({
        //       message: "错误",
        //       description: res.errmsg,
        //       duration: 4,
        //     });
        //   }
        // });

        //TODO 公共的图片上传
        // this.$common.serverIp() + '/upload.php'
      } else {
        return;
      }
    },

    beforeRead() {
      return true;
    },
    addPerson: {},

    deletePerson() {
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要删除当前游客？",
      }).then(() => {
        this.person_show = false;
        // _.remove(this.course_data,);
        this.course_data.splice(this.person_index, 1);
        this.person_index = -1;
        // 保证第一位始终为签约人
        if (this.course_data.length > 0) {
          if (typeof this.course_data[0].isSigner === 'undefined') {
            this.$set(this.course_data[0], 'isSigner', '1');
          } else {
            this.course_data[0].isSigner = '1';
          }
        }
      });
    },

    editPerson(item, index) {
      this.person_index = index;
      this.current_person = this.course_data[this.person_index];
      // 约束：第一位游客必须为签约人，其余默认非签约人
      if (this.person_index === 0) {
        this.$set(this.current_person, "isSigner", "1");
      } else if (typeof this.current_person.isSigner === "undefined") {
        this.$set(this.current_person, "isSigner", "0");
      }
      this.person_show = true;
    },

    cardtypeTxt(type) {
      // <option value="1">身份证</option>
      //             <option value="4">护照</option>
      //             <option value="6">回乡证</option>
      if (type == 1) {
        return "身份证";
      }

      if (type == 4) {
        return "护照";
      }

      if (type == 6) {
        return "回乡证";
      }

      if (type == 8) {
        return "其他";
      }
      return;
    },

    addCourse() {
      const willBeFirst = this.course_data.length === 0;
      this.course_data.push({
        // id: this.course_data.length + 1,
        name: "",
        area: "",
        address: "",
        industry_name: "",
        branch_scheme: "",
        size: "",
        editable: true,
        isSigner: willBeFirst ? "1" : "0",
        gender: "",
      });

      this.person_index = this.course_data.length - 1;
      this.current_person = this.course_data[this.person_index];
      this.person_show = true;
    },

    // 自愿购物
    addShopping() {
      this.shoppings.push({ date: '', place: '', shoppingPlace: '', goods: '', stayDuration: '', memo: '' });
      this.shopping_index = this.shoppings.length - 1;
      this.current_shopping = this.shoppings[this.shopping_index];
      this.shopping_show = true;
    },
    editShopping(item, index) {
      this.shopping_index = index;
      this.current_shopping = this.shoppings[this.shopping_index];
      this.shopping_show = true;
    },
    deleteShopping() {
      if (typeof this.shopping_index === 'number' && this.shopping_index > -1) {
        this.shoppings.splice(this.shopping_index, 1);
      }
      this.shopping_index = -1;
      this.shopping_show = false;
    },

    choseTemplate() {
      this.person_show = false;
    },

    saveDraft() {
      //TODO 暂存草稿操作
      Dialog.confirm({
        title: "操作提醒",
        message: "是否将资料暂存草稿？",
      })
        .then(() => {
          // on confirm
          //TODO:清空
          // this.pay_username = '';
          // this.collection_username = '';
          // this.price = '';
          // this.pay_date = moment().format('YYYY-MM-DD')
          // this.attachment = '';

          //处理游客信息
          let _self = this;

          //还是要判断格式，就算存草稿也要正确格式的
          //遍历校验数据是否填写完全
          for (let i = 0, j = _self.course_data.length; i < j; i++) {
            if (!_self.course_data[i].name) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客姓名不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客姓名不能为空`);
              return false;
            }

            if (!_self.course_data[i].cardtype) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客证件类型不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客证件类型不能为空`);
              return false;
            }

            if (!_self.course_data[i].idcard) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客证件号不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客证件号不能为空`);
              return false;
            }

            //TDOO
            if (
              _self.course_data[i].cardtype == 1 &&
              !/(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(_self.course_data[i].idcard)
            ) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客身份证号格式异常`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客身份证号格式异常`);
              return false;
            }

            if (!_self.course_data[i].phone) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客手机号不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客手机号不能为空`);
              return false;
            }

            // /^1\d{10}$/

            if (!/^1\d{10}$/.test(_self.course_data[i].phone)) {
              //   _self.$notification['error']({
              //     message: '错误',
              //     description: '手机号格式异常',
              //     duration: 4,
              //   })
              common.mAlert(this, `第${i + 1}个游客手机号格式异常`);
              return;
            }

            if (!_self.course_data[i].is_child) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: "是否儿童不能为空",
              //     duration: 4,
              //   });
              common.mAlert(this, `是否儿童不能为空`);
              return false;
            }

            // if (i == 0) {
            //   if (!_self.course_data[i].address) {
            //     // _self.$notification["error"]({
            //     //   message: "错误",
            //     //   description: `游客代表地址不能为空`,
            //     //   duration: 4,
            //     // });
            //     common.mAlert(this, `游客代表地址不能为空`);

            //     return false;
            //   }
            // }
          }

          console.log("游客信息输出");
          console.log(_self.course_data);
          //   return {
          //     contract_person_json: JSON.stringify(_self.course_data),
          //     contract_person_count: _self.course_data.length,
          //     contract_main_phone: _self.course_data.length
          //       ? _self.course_data[0].phone
          //       : "",
          //     contract_main_name: _self.course_data.length
          //       ? _self.course_data[0].name
          //       : "",
          //   };

          // 补齐签约人字段：第一个固定为 '1'，其他默认 '0'
          _self.course_data = _self.course_data.map(function(p, idx){
            var cloned = Object.assign({}, p);
            if (idx === 0) {
              cloned.isSigner = '1';
            } else if (typeof cloned.isSigner === 'undefined') {
              cloned.isSigner = '0';
            }
            return cloned;
          });

          // let contract_plane =
          //   this.contract_type != "E00001" ? "" : this.$refs.plane.getData();
          // let contract_hotel =
          //   this.contract_type != "E00001" ? "" : this.$refs.hotel.getData();
          // let contract_car =
          //   this.contract_type != "E00001" ? "" : this.$refs.car.getData();
          // let contract_dao =
          //   this.contract_type != "E00001" ? "" : this.$refs.dao.getData();
          // let contract_visa =
          //   this.contract_type != "E00001" ? "" : this.$refs.visa.getData();

          common
            .cusHttp(
              this,
              "/admin_user.php?action=add_or_modify_job",
              {
                id: this.id,
                contract_begin_day: this.contract_begin_day,
                contract_end_day: this.contract_end_day,
                contract_pay_day: this.contract_pay_day,
                contract_name: this.contract_name,

                contract_adult_price: this.contract_adult_price,
                contract_child_price: this.contract_child_price,
                contract_adult_count: this.contract_adult_count,
                contract_child_count: this.contract_child_count,
                contract_price: this.contract_price,
                contract_pay_remark: this.contract_pay_remark,
                contract_payway: this.contract_payway,
                contract_service_price: this.contract_service_price,
                contract_single_price: this.contract_single_price,

                contract_insurance_method: this.contract_insurance_method,
                contract_insurance_productname:
                  this.contract_insurance_productname,
                contract_group_min_count: this.contract_group_min_count,
                contract_group_way: this.contract_group_way,
                contract_group_othername: this.contract_group_othername,
                contract_group_agree: this.contract_group_agree,
                contract_dispute_tribunalname:
                  this.contract_dispute_tribunalname,
                contract_dispute_way: 2,
                contract_days: this.contract_days,
                contract_nights: this.contract_nights,

                contract_person_json: JSON.stringify(_self.course_data),
                contract_person_count: _self.course_data.length,
                contract_main_phone: _self.course_data.length
                  ? _self.course_data[0].phone
                  : "",
                contract_main_name: _self.course_data.length
                  ? _self.course_data[0].name
                  : "",

                contract_attachment: JSON.stringify(_self.fileList),
                shoppings: JSON.stringify(this.shoppings),
                contract_plane:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.plane.getData(),
                contract_hotel:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.hotel.getData(),
                contract_car:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.car.getData(),
                contract_dao:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.dao.getData(),
                contract_visa:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.visa.getData(),
                contract_other:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.other.getData(),
                contract_rule:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.rule.getData(),
              },
              "post"
            )
            .then((res) => {
              common.mAlert(this, "暂存草稿成功");
              //   console.log("job_detail返回", res);
              //   res = JSON.parse(res.data);
              //   if (res.errcode == 0) {
              //     // this.static = res.data
              //     // console.log(JSON.stringify(res.data.loan_list));
              //     // this.list = res.data.loan_list;
              //     //   this.pending_list = res.result.data
              //     //   this.currentListLoading = false
              //     let info = res.data;
              //     this.info = info;

              //     this.contract_type = info.contract_type;
              //     console.log("输出Info");
              //     console.log(this.info);
              //   }
            });
        })
        .catch(() => {
          // on cancel
          //返回上一页
          //   this.$router.push("/invoice");
        });
    },



    doPreview() {
      // 预览操作
      let _self = this;

      /** start of  产品信息和费用 **/
      if (!_self.contract_name) {
        common.mAlert(this, `线路名称不能为空`);
        return false;
      }

      if (!_self.course_data.length) {
        common.mAlert(this, `至少需要一位游客`);
        return false;
      }

      // 游客信息校验
      for (let i = 0, j = _self.course_data.length; i < j; i++) {
        if (!_self.course_data[i].name) {
          common.mAlert(this, `第${i + 1}个游客姓名不能为空`);
          return false;
        }
        if (!_self.course_data[i].cardtype) {
          common.mAlert(this, `第${i + 1}个游客证件类型不能为空`);
          return false;
        }
        if (!_self.course_data[i].idcard) {
          common.mAlert(this, `第${i + 1}个游客证件号不能为空`);
          return false;
        }
        if (
          _self.course_data[i].cardtype == 1 &&
          !/(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(_self.course_data[i].idcard)
        ) {
          common.mAlert(this, `第${i + 1}个游客身份证号格式异常`);
          return false;
        }
        if (!_self.course_data[i].phone) {
          common.mAlert(this, `第${i + 1}个游客手机号不能为空`);
          return false;
        }
        if (!/^1\d{10}$/.test(_self.course_data[i].phone)) {
          common.mAlert(this, `第${i + 1}个游客手机号格式异常`);
          return;
        }
        if (!_self.course_data[i].is_child) {
          common.mAlert(this, `是否儿童不能为空`);
          return false;
        }
      }

      if (this.contract_type == "E00001") {
      } else {
        if (!_self.contract_begin_day) {
          common.mAlert(this, `出发日期不能为空`);
          return false;
        }
        if (!_self.contract_end_day) {
          common.mAlert(this, `结束日期不能为空`);
          return false;
        }
        if (!_self.contract_days) {
          common.mAlert(this, `天数不能为空`);
          return false;
        }
        if (_self.contract_nights === "") {
          common.mAlert(this, `夜晚数不能为空`);
          return false;
        }
        if (!_self.contract_adult_price) {
          common.mAlert(this, `成人价不能为空`);
          return false;
        }
        if (!_self.contract_child_price) {
          common.mAlert(this, `儿童价不能为空`);
          return false;
        }
        if (!_self.contract_service_price) {
          common.mAlert(this, `导游服务费不能为空`);
          return false;
        }
        if (!_self.contract_single_price) {
          common.mAlert(this, `单房差不能为空`);
          return false;
        }
        if (_self.contract_adult_count === "") {
          common.mAlert(this, `成人人数不能为空`);
          return false;
        }
        if (_self.contract_child_count === "") {
          common.mAlert(this, `儿童人数不能为空`);
          return false;
        }
        if (!_self.contract_price) {
          common.mAlert(this, `旅游费用不能为空`);
          return false;
        }
        if (!_self.contract_payway) {
          common.mAlert(this, `支付方式不能为空`);
          return false;
        }
        if (!_self.contract_pay_day) {
          common.mAlert(this, `支付时间不能为空`);
          return false;
        }

        /** end of 产品信息和费用 **/

        if (!_self.contract_insurance_method) {
          common.mAlert(this, `意外伤害保险不能为空`);
          return false;
        }
        if (_self.contract_group_min_count === "") {
          common.mAlert(this, `最低成团人数不能为空`);
          return false;
        }
        if (!_self.contract_group_way) {
          common.mAlert(this, `不成团约定不能为空`);
          return false;
        }
        if (!_self.contract_group_agree) {
          common.mAlert(this, `拼团约定不能为空`);
          return false;
        }
        if (!_self.fileList.length) {
          common.mAlert(this, `附件不能为空`);
          return false;
        }
      }

      // 补齐签约人字段
      _self.course_data = _self.course_data.map(function(p, idx){
        var cloned = Object.assign({}, p);
        if (idx === 0) {
          cloned.isSigner = '1';
        } else if (typeof cloned.isSigner === 'undefined') {
          cloned.isSigner = '0';
        }
        return cloned;
      });

      Toast.loading({
        duration: 0,
        mask: true,
        message: "正在生成预览...",
      });

      // 1. 先保存 (使用 add_or_modify_job)
      common
        .cusHttp(
          this,
          "/admin_user.php?action=add_or_modify_job",
          {
            id: this.id,
            contract_begin_day: this.contract_begin_day,
            contract_end_day: this.contract_end_day,
            contract_pay_day: this.contract_pay_day,
            contract_name: this.contract_name,

            contract_adult_price: this.contract_adult_price,
            contract_child_price: this.contract_child_price,
            contract_adult_count: this.contract_adult_count,
            contract_child_count: this.contract_child_count,
            contract_price: this.contract_price,
            contract_pay_remark: this.contract_pay_remark,
            contract_payway: this.contract_payway,
            contract_service_price: this.contract_service_price,
            contract_single_price: this.contract_single_price,
            contract_days: this.contract_days,
            contract_nights: this.contract_nights,

            contract_insurance_method: this.contract_insurance_method,
            contract_insurance_productname: this.contract_insurance_productname,
            contract_group_min_count: this.contract_group_min_count,
            contract_group_way: this.contract_group_way,
            contract_group_othername: this.contract_group_othername,
            contract_group_agree: this.contract_group_agree,
            contract_dispute_tribunalname: this.contract_dispute_tribunalname,
            contract_dispute_way: 2,

            contract_person_json: JSON.stringify(_self.course_data),
            contract_person_count: _self.course_data.length,
            contract_main_phone: _self.course_data.length
              ? _self.course_data[0].phone
              : "",
            contract_main_name: _self.course_data.length
              ? _self.course_data[0].name
              : "",

            contract_attachment: JSON.stringify(_self.fileList),
            shoppings: JSON.stringify(this.shoppings),
            contract_plane:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.plane.getData(),
            contract_hotel:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.hotel.getData(),
            contract_car:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.car.getData(),
            contract_dao:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.dao.getData(),
            contract_visa:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.visa.getData(),
            contract_other:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.other.getData(),
            contract_rule:
              this.contract_type != "E00001"
                ? ""
                : this.$refs.rule.getData(),
          },
          "post"
        )
        .then((res) => {
          // 保存成功，请求预览
          res = JSON.parse(res.data);
           if (res.errcode == 0) {
              common.cusHttp(
                this,
                "/admin_user.php?action=preview_contract",
                { id: this.id },
                "get"
              ).then((previewRes) => {
                  Toast.clear();
                  let pRes = JSON.parse(previewRes.data);
                  if(pRes.errcode == 0){
                      window.open(pRes.url, "_blank");
                  } else {
                      common.mAlert(this, pRes.errmsg || "预览生成失败");
                  }
              }).catch(() => {
                  Toast.clear();
                  common.mAlert(this, "预览请求异常");
              });
           } else {
              Toast.clear();
              common.mAlert(this, res.errmsg || "保存失败");
           }
        })
        .catch(() => {
          Toast.clear();
          common.mAlert(this, "服务异常");
        });
    },


    // 生成预览
    previewContract() {
      this.saveContract(true)
    },

    // 提交合同
    submitContract() {
      this.saveContract(false)
    },

    saveContract(isPreview = false) {
      //TODO 暂存草稿操作
      const confirmText = isPreview 
        ? '是否确认要生成合同预览？' 
        : '是否确认要提交合同？点确定表示你已仔细核对过填写内容。'
      
      Dialog.confirm({
        title: "操作提醒",
        message: confirmText,
      })
        .then(() => {
          // on confirm
          //TODO:清空
          // this.pay_username = '';
          // this.collection_username = '';
          // this.price = '';
          // this.pay_date = moment().format('YYYY-MM-DD')
          // this.attachment = '';

          //处理游客信息
          let _self = this;

          /** start of  产品信息和费用 **/
          if (!_self.contract_name) {
            common.mAlert(this, `线路名称不能为空`);
            return false;
          }

          if (!_self.course_data.length) {
            common.mAlert(this, `至少需要一位游客`);
            return false;
          }

          //还是要判断格式，就算存草稿也要正确格式的
          //遍历校验数据是否填写完全
          for (let i = 0, j = _self.course_data.length; i < j; i++) {
            if (!_self.course_data[i].name) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客姓名不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客姓名不能为空`);
              return false;
            }

            if (!_self.course_data[i].cardtype) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客证件类型不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客证件类型不能为空`);
              return false;
            }

            if (!_self.course_data[i].idcard) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客证件号不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客证件号不能为空`);
              return false;
            }

            //TDOO
            if (
              _self.course_data[i].cardtype == 1 &&
              !/(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(_self.course_data[i].idcard)
            ) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客身份证号格式异常`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客身份证号格式异常`);
              return false;
            }

            if (!_self.course_data[i].phone) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: `第${i + 1}个游客手机号不能为空`,
              //     duration: 4,
              //   });
              common.mAlert(this, `第${i + 1}个游客手机号不能为空`);
              return false;
            }

            // /^1\d{10}$/

            if (!/^1\d{10}$/.test(_self.course_data[i].phone)) {
              //   _self.$notification['error']({
              //     message: '错误',
              //     description: '手机号格式异常',
              //     duration: 4,
              //   })
              common.mAlert(this, `第${i + 1}个游客手机号格式异常`);
              return;
            }

            if (!_self.course_data[i].is_child) {
              //   _self.$notification["error"]({
              //     message: "错误",
              //     description: "是否儿童不能为空",
              //     duration: 4,
              //   });
              common.mAlert(this, `是否儿童不能为空`);
              return false;
            }

            // if (i == 0) {
            //   if (!_self.course_data[i].address) {
            //     // _self.$notification["error"]({
            //     //   message: "错误",
            //     //   description: `游客代表地址不能为空`,
            //     //   duration: 4,
            //     // });
            //     common.mAlert(this, `游客代表地址不能为空`);

            //     return false;
            //   }
            // }
          }

          if (this.contract_type == "E00001") {
          } else {
            if (!_self.contract_begin_day) {
              common.mAlert(this, `出发日期不能为空`);
              return false;
            }

            if (!_self.contract_end_day) {
              common.mAlert(this, `结束日期不能为空`);
              return false;
            }

            if (!_self.contract_days) {
              common.mAlert(this, `天数不能为空`);
              return false;
            }

            if (_self.contract_nights === "") {
              common.mAlert(this, `夜晚数不能为空`);
              return false;
            }

            if (!_self.contract_adult_price) {
              common.mAlert(this, `成人价不能为空`);
              return false;
            }

            if (!_self.contract_child_price) {
              common.mAlert(this, `儿童价不能为空`);
              return false;
            }

            if (!_self.contract_service_price) {
              common.mAlert(this, `导游服务费不能为空`);
              return false;
            }

            if (!_self.contract_single_price) {
              common.mAlert(this, `单房差不能为空`);
              return false;
            }

            if (_self.contract_adult_count === "") {
              common.mAlert(this, `成人人数不能为空`);
              return false;
            }

            if (_self.contract_child_count === "") {
              common.mAlert(this, `儿童人数不能为空`);
              return false;
            }

            if (!_self.contract_price) {
              common.mAlert(this, `旅游费用不能为空`);
              return false;
            }

            if (!_self.contract_payway) {
              common.mAlert(this, `支付方式不能为空`);
              return false;
            }

            if (!_self.contract_pay_day) {
              common.mAlert(this, `支付时间不能为空`);
              return false;
            }

            /** end of 产品信息和费用 **/

            // console.log("游客信息输出");
            // console.log(_self.course_data);
            console.log("值都保存到这里了");

            if (!_self.contract_insurance_method) {
              common.mAlert(this, `意外伤害保险不能为空`);
              return false;
            }

            if (_self.contract_group_min_count === "") {
              common.mAlert(this, `最低成团人数不能为空`);
              return false;
            }

            if (!_self.contract_group_way) {
              common.mAlert(this, `不成团约定不能为空`);
              return false;
            }

            if (!_self.contract_group_agree) {
              common.mAlert(this, `拼团约定不能为空`);
              return false;
            }

            // if (!_self.contract_dispute_way) {
            //   common.mAlert(this, `争议解决方式不能为空`);
            //   return false;
            // }

            if (!_self.fileList.length) {
              common.mAlert(this, `附件不能为空`);
              return false;
            }
          }

          // 补齐签约人字段：第一个固定为 '1'，其他默认 '0'
          _self.course_data = _self.course_data.map(function(p, idx){
            var cloned = Object.assign({}, p);
            if (idx === 0) {
              cloned.isSigner = '1';
            } else if (typeof cloned.isSigner === 'undefined') {
              cloned.isSigner = '0';
            }
            return cloned;
          });

          Toast.loading({
            duration: 0,
            mask: true,
            message: isPreview ? "预览生成中..." : "合同生成中...",
          });

          common
            .cusHttp(
              this,
              "/admin_user.php?action=add_or_modify_job_then_submit",
              {
                id: this.id,
                is_preview: isPreview ? 1 : 0,
                contract_begin_day: this.contract_begin_day,
                contract_end_day: this.contract_end_day,
                contract_pay_day: this.contract_pay_day,
                contract_name: this.contract_name,

                contract_adult_price: this.contract_adult_price,
                contract_child_price: this.contract_child_price,
                contract_adult_count: this.contract_adult_count,
                contract_child_count: this.contract_child_count,
                contract_price: this.contract_price,
                contract_pay_remark: this.contract_pay_remark,
                contract_payway: this.contract_payway,
                contract_service_price: this.contract_service_price,
                contract_single_price: this.contract_single_price,
                contract_days: this.contract_days,
                contract_nights: this.contract_nights,

                contract_insurance_method: this.contract_insurance_method,
                contract_insurance_productname:
                  this.contract_insurance_productname,
                contract_group_min_count: this.contract_group_min_count,
                contract_group_way: this.contract_group_way,
                contract_group_othername: this.contract_group_othername,
                contract_group_agree: this.contract_group_agree,
                contract_dispute_tribunalname:
                  this.contract_dispute_tribunalname,
                contract_dispute_way: 2,

                contract_person_json: JSON.stringify(_self.course_data),
                contract_person_count: _self.course_data.length,
                contract_main_phone: _self.course_data.length
                  ? _self.course_data[0].phone
                  : "",
                contract_main_name: _self.course_data.length
                  ? _self.course_data[0].name
                  : "",

                contract_attachment: JSON.stringify(_self.fileList),
                shoppings: JSON.stringify(this.shoppings),
                contract_plane:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.plane.getData(),
                contract_hotel:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.hotel.getData(),
                contract_car:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.car.getData(),
                contract_dao:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.dao.getData(),
                contract_visa:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.visa.getData(),
                contract_other:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.other.getData(),
                contract_rule:
                  this.contract_type != "E00001"
                    ? ""
                    : this.$refs.rule.getData(),
              },
              "post"
            )
            .then((res) => {
              //TODO 成功了跳转
              console.log("生产合同");
              console.log(res);
              Toast.clear();

              res = JSON.parse(res.data);
              if (res.errcode == 0) {
                const successMessage = isPreview ? "预览生成成功" : "合同生成成功"
                Dialog.alert({
                  title: "提示",
                  message: successMessage,
                }).then(() => {
                  // on close
                  if (!isPreview) {
                    this.$router.push({ path: "/" });
                  }
                });
              } else {
                common.mAlert(this, res.errmsg);
              }

              // common.mAlert(this, "暂存草稿成功");
              //   console.log("job_detail返回", res);
              //   res = JSON.parse(res.data);
              //   if (res.errcode == 0) {
              //     // this.static = res.data
              //     // console.log(JSON.stringify(res.data.loan_list));
              //     // this.list = res.data.loan_list;
              //     //   this.pending_list = res.result.data
              //     //   this.currentListLoading = false
              //     let info = res.data;
              //     this.info = info;

              //     this.contract_type = info.contract_type;
              //     console.log("输出Info");
              //     console.log(this.info);
              //   }
            });
        })
        .catch(() => {
          Toast.clear();
          // on cancel
          //返回上一页
          //   this.$router.push("/invoice");
          common.mAlert(this, "服务异常");
        });
    },

    showImage() {
      this.show = true;
    },
    goSms() {
      if (!/^1[0-9]\d{9}$/.test(this.mobile)) {
        this.$layer.msg("请输入正确的手机号");
        return;
      }

      if (!/^[0-4|6-9][0-9]{15,18}$/.test(this.account)) {
        common.mAlert(this, "请输入正确的银行卡号");
        return;
      }

      if (!this.mobile) {
        common.mAlert(this, "银行预留手机号不能为空");
        return;
      }

      if (this.second) {
        return;
      }

      this.second = 60;
      this.smsText = this.second + "秒";
      this.smsFlag = true;

      (function (a) {
        var countDownHandler = setInterval(function () {
          a.second = a.second - 1;
          if (a.second < 1) {
            clearInterval(countDownHandler);
            a.second = 0;
            a.smsText = "获取验证码";
            return;
          }
          a.smsText = a.second + "秒";
        }, 1000);
      })(this);

      this.$http
        .post(common.dynamicHost() + "/bor/bankcard", {
          id: this.id,
          mobile: this.mobile,
          bank_code: this.bank_code,
          account: this.account,
        })
        .then((res) => {
          if (res.data.status) {
            this.$layer.msg("发送成功");
          }
        })
        .catch((err) => {});
    },
    showBank() {
      common.setTitle("绑定还款银行卡");
      this.bankShow = true;
    },
    nextStep() {
      if (this.nextLock) {
        return;
      }

      if (this.invoiceType == -1) {
        common.mAlert(this, "发票类型不能为空");
        return;
      }

      if (!this.title) {
        common.mAlert(this, "发票抬头不能为空");
        return;
      }

      if (!this.taxpayer_number && this.invoiceType == 2) {
        common.mAlert(this, "请填写纳税人识别号");
        return;
      }

      // if ( !this.email )
      // {
      //     common.mAlert(this,'电子邮箱不能为空');
      //     return;
      // }

      //如果是企业开票的话，授权书是肯定不能少的哟
      if (this.invoiceType == 2 && !this.faceImg) {
        common.mAlert(this, "请上传企业开票授权书");
        return;
      }

      if (!this.price) {
        common.mAlert(this, "请输入金额");
        return;
      }

      if (!this.contract_no) {
        common.mAlert(this, "请输入合同号");
        return;
      }

      // location.href = 'status'
      /*加锁防止二次触发*/
      this.nextLock = true;
      common
        .cusHttp(
          this,
          "/api/save_invoice",
          {
            title: this.title,
            email: this.email,
            taxpayer_number: this.taxpayer_number,
            ids: this.chosenIds,
            type: this.invoiceType,
            shouquanshu: this.shouquanshu,
            taxpayer_phone: this.taxpayer_phone,
            bank_name: this.taxpayer_bank,
            bank_account: this.bank_account,
            taxpayer_address: this.taxpayer_address,
            price: this.price,
          },
          "post"
        )
        .then((res) => {
          this.nextLock = false;
          console.log(res);
          if (res.data.errcode == 0) {
            /**弹出confirm再录一笔，或者返回列表**/
            Dialog.confirm({
              title: "添加成功",
              message: "是否留在当前页面继续添加？",
            })
              .then(() => {
                // on confirm
                //TODO:清空
                // this.pay_username = '';
                // this.collection_username = '';
                // this.price = '';
                // this.pay_date = moment().format('YYYY-MM-DD')
                // this.attachment = '';
              })
              .catch(() => {
                // on cancel
                //返回上一页
                this.$router.push("/invoice");
              });
          } else {
            common.mAlert(this, res.data.errmsg);
          }
        })
        .catch((err) => {});
    },
    closeLayer: function () {
      this.layerFlag = false;
    },

    uploadImg() {
      this.$refs.filElem.dispatchEvent(new MouseEvent("click"));
    },
    initPage() {
      common
        .cusHttp(
          this,
          "/admin_user.php?action=job_detail",
          { id: this.id },
          "get"
        )
        .then((res) => {
          console.log("job_detail返回", res);
          res = JSON.parse(res.data);
          if (res.errcode == 0) {
            // this.static = res.data
            // console.log(JSON.stringify(res.data.loan_list));
            // this.list = res.data.loan_list;
            //   this.pending_list = res.result.data
            //   this.currentListLoading = false
            let info = res.data;
            this.info = info;

            this.contract_type = info.contract_type;
            this.contract_begin_day = info.contract_begin_day;
            this.contract_end_day = info.contract_end_day;
            this.contract_pay_day = info.contract_pay_day;
            this.contract_name = info.contract_name;

            this.contract_adult_price = info.contract_adult_price;
            this.contract_child_price = info.contract_child_price;
            this.contract_adult_count = info.contract_adult_count;
            this.contract_child_count = info.contract_child_count;
            this.contract_price = info.contract_price;
            this.contract_pay_remark = info.contract_pay_remark;
            this.contract_payway = info.contract_payway;

            this.contract_days = info.contract_days;
            this.contract_nights = info.contract_nights;

            this.contract_service_price = info.contract_service_price;
            this.contract_single_price = info.contract_single_price;

            this.contract_insurance_method = info.contract_insurance_method;
            this.contract_insurance_productname =
              info.contract_insurance_productname;
            this.contract_group_min_count = info.contract_group_min_count;
            this.contract_group_way = info.contract_group_way;

            this.contract_group_othername = info.contract_group_othername;
            this.contract_group_agree = info.contract_group_agree;
            this.contract_dispute_tribunalname =
              info.contract_dispute_tribunalname;
            this.contract_dispute_way = 2;

            // contract_insurance_method: this.contract_insurance_method,
            // contract_insurance_productname: this.contract_insurance_productname,
            // contract_group_min_count: this.contract_group_min_count,
            // contract_group_way: this.contract_group_way,
            // contract_group_othername: this.contract_group_othername,
            // contract_group_agree: this.contract_group_agree,
            // contract_dispute_tribunalname: this.contract_dispute_tribunalname,

            if (this.info.contract_person_json) {
              this.course_data = JSON.parse(this.info.contract_person_json);
              // 兼容历史数据：补齐 isSigner，且第一位固定为 '1'
              this.course_data = this.course_data.map(function(p, idx){
                var cloned = Object.assign({}, p);
                if (idx === 0) {
                  cloned.isSigner = '1';
                } else if (typeof cloned.isSigner === 'undefined') {
                  cloned.isSigner = '0';
                }
                return cloned;
              });
            }

            if (this.info.contract_attachment) {
              console.log("进来了");
              this.fileList = JSON.parse(this.info.contract_attachment);
            }
            // 初始化自愿购物
            if (this.info.shoppings) {
              try {
                this.shoppings = JSON.parse(this.info.shoppings) || [];
              } catch (e) {
                this.shoppings = [];
              }
            }

            //   contract_adult_price: this.contract_adult_price,
            // contract_child_price: this.contract_child_price,
            // contract_adult_count: this.contract_adult_count,
            // contract_child_count: this.contract_child_count,
            // contract_price: this.contract_price,
            // contract_pay_remark: this.contract_pay_remark,
            // contract_payway: this.contract_payway
            // contract_service_price: this.contract_service_price,
            // contract_single_price: this.contract_single_price
            console.log("输出Info");
            console.log(this.info);

            if (this.contract_type == "E00001") {
              this.$nextTick(() => {
                console.log("触发初始值设置");
                
                this.$refs.plane.init(this.info.contract_plane);
                this.$refs.hotel.init(this.info.contract_hotel);
                this.$refs.car.init(this.info.contract_car);
                this.$refs.dao.init(this.info.contract_dao);
                this.$refs.visa.init(this.info.contract_visa);
                this.$refs.other.init(this.info.contract_other);
                this.$refs.rule.init(this.info.contract_rule);
              });
            }
          }
        });
    },
  },
  created: function () {
    /**
     * 如果没有token则跳到登录页哟
     */
    common.checkToken(this);

    console.log("合同详情", this.id);
    this.initPage();
  },
  mounted() {
    // this.$store.commit("setTarbarIndex", 2);
  },
  computed: {
    nextStepValid: function () {
      return true;
    },
    facePath: function () {
      return common.dynamicHost() + this.faceImg;
    },
    images: function () {
      return [common.dynamicHost() + this.faceImg];
    },
  },
};
</script>


<style>
html,
body {
  background-color: #f8f8f8 !important;
}

input::-webkit-input-placeholder {
  padding-top: 0;
  line-height: normal;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.inEdit {
  opacity: 0.4;
}

.disableText {
  color: #999999 !important;
}

.in-bl {
  display: inline-block;
}

.common-padding {
  padding: 0 0.625rem;
}
.common-padding2 {
  padding: 0.4rem 0.625rem;
}

.fc-aaaaaa-fs-nor-m {
  font-family: PingFangSC-Medium;
  font-size: 0.4375rem;
  color: #aaaaaa;
  line-height: 0.625rem;
}

.camera_text {
  line-height: 0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.3rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #1889f9;
}

.bank-desc {
  font-family: PingFangSC-Regular;
  font-size: 0.438rem;
  color: #111111;
  line-height: 0.625rem;
}

.ps-text {
  font-size: 0.22rem;
  line-height: 0.3rem;
  color: #666666;
}
</style>
